const configHeaders = {
  Authorization: "Api-Key LaaXj3ft.hGbRWxHo6KKsYGJ9SYdTRhwBBGo5fELG",
  "content-type": "application/json",
};

export default configHeaders;
